import { ClientEntity } from 'src/app/models/clients';
import {
  IPerformanceData,
  IAssetPerformanceData,
  ReturnTypes,
  ReturnSymbol,
  ReturnSpanMonths,
  DateSelectorCaption,
  PerformanceSettings,
} from 'src/app/models/performance';
import { IPortfolio } from "../../models/portfolios";

export interface PerformanceState {
  performanceData: IPerformanceData;
  assetPerformanceData: IAssetPerformanceData[];
  performanceTabsHeaderData: {};
  selectedDate?: Date;
  selectedEntities?: ClientEntity[];
  selectedPortfolios?: IPortfolio[];
  settings: PerformanceSettings;
  retrieveData?: boolean;
  loading: boolean;
  assetPerformanceDataLoading: boolean;
  error: boolean;
  errorMessage: string;

  // Performance and Asset Performance Data should be in a separate state
  assetError: boolean;
  assetErrorMessage: string;
}

export interface IPerformanceStateErrorLoading {
  performanceData: IPerformanceData;
  loading: boolean;
  error: boolean;
}

export const initialPerformanceState: PerformanceState = {
  performanceData: {},
  assetPerformanceData: [],
  performanceTabsHeaderData: {},
  settings: {
    selectedReturnSpanMonths: ReturnSpanMonths.INCEPTION,
    selectedReturnPeriod: DateSelectorCaption.MONTH,
    selectedReturnType: ReturnTypes.XIRR,
    selectedReturnSymbol: ReturnSymbol.PERCENT,
  },
  retrieveData: false,
  loading: false,
  assetPerformanceDataLoading: false,
  error: false,
  errorMessage: '',

  // Performance and Asset Performance Data should be in a separate state
  assetError: false,
  assetErrorMessage: ''
};
